import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, viewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'custom-number-input-type',
  templateUrl: './custom-number-input-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, FormlyModule, NgClass],
})
export class CustomNumberInputTypeComponent extends FieldType<FieldTypeConfig> {
  readonly input = viewChild<ElementRef<HTMLInputElement>>('customNumberInput');
  textInputFieldTypes = ['text'];

  onPopulate(field: FormlyFieldConfig) {
    if (!field.props?.type) {
      field.props.type = 'text';
      return;
    }

    if (!this.textInputFieldTypes.includes(field.props.type)) {
      throw new Error(
        'parameter <templateOptions.type> is not valid for TextInputFieldComponent, only text, email, password and tel are possible values'
      );
    }
  }
  inputValidator(event: any) {
    const pattern = /^[0-9]*$/;
    if (!pattern.test(event.target.value)) {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
      const inputElement: HTMLInputElement = this.input().nativeElement as HTMLInputElement;
      inputElement.dispatchEvent(new InputEvent('input'));
    }
  }
}
